/**
 * Leveringslinje under købsknap: tekst pr. variant (lager / fjernlager + metafelt).
 */
(function () {
  function parseI18n(root) {
    var el = document.getElementById('chd-same-day-i18n-' + root.dataset.sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    if (root.getAttribute('data-chd-delivery-line-init')) return;
    root.setAttribute('data-chd-delivery-line-init', 'true');

    var i18n = parseI18n(root);
    var out = root.querySelector('[data-chd-same-day-root]');
    var section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    if (!i18n || !out || !i18n.variants) return;

    var selectedId = String(root.getAttribute('data-selected-variant-id') || '');

    function lineForId(id) {
      if (!id || !i18n.variants) return '';
      return i18n.variants[id] !== undefined ? i18n.variants[id] : '';
    }

    function render() {
      var line = lineForId(selectedId);
      out.textContent = line || '';
    }

    render();

    if (section) {
      section.addEventListener('variant:changed', function (ev) {
        var v = ev.detail && ev.detail.variant;
        if (v && v.id) {
          selectedId = String(v.id);
          root.setAttribute('data-selected-variant-id', selectedId);
          root.setAttribute('data-variant-available', v.available ? 'true' : 'false');
          render();
        } else {
          selectedId = '';
          root.setAttribute('data-variant-available', 'false');
          render();
        }
      });
    }
  }

  function run() {
    document.querySelectorAll('[data-chd-same-day]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
